import { ProductDetailsService } from '@product-details/services/product-details.service';
import { AdditionalServicesService } from '@additional-services/services/additional-services.service';
import { CompleteOrderService } from '@complete-order/services/complete-order.service';
import { ViewOffersService } from '@view-offers/services/view-offers.service';
import {
  GAProductDetailsPageLoad,
  GAProductDetailsThumbnailClick,
  GADeliveryUnavailableModal,
  GADeliveryApiErrorModal,
  GAProductDetailsContinueCTAClick,
} from '@analytics/classes/ga.product.details.class';
import { AnalyticsService } from '@analytics/services/analytics.service';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromAnalytics from '../actions';
import { tap, withLatestFrom } from 'rxjs/operators';

@Injectable()
export class GAProductDetailsEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly analyticsService: AnalyticsService,
    private readonly viewOffersService: ViewOffersService,
    public readonly productDetailsService: ProductDetailsService,
    private readonly additionalServicesService: AdditionalServicesService,
    private readonly completeOrderService: CompleteOrderService
  ) {}

  PageLoad$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromAnalytics.ProductDetailsPageLoad),
        withLatestFrom(
          this.viewOffersService.offers$,
          this.productDetailsService.selected$,
          this.completeOrderService.replacementCost$
        ),
        tap(([, offers, selected, replacementCost]) => {
          const gaData = new GAProductDetailsPageLoad(
            offers,
            selected,
            replacementCost
          ).gaData;
          this.analyticsService.eventEmitter(gaData);
        })
      ),
    { dispatch: false }
  );

  ContinueClick$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromAnalytics.ProductDetailsContinueClick),
        withLatestFrom(
          this.viewOffersService.offers$,
          this.productDetailsService.selected$,
          this.completeOrderService.replacementCost$
        ),
        tap(([, offers, selected, cost]) => {
          const gaData = new GAProductDetailsContinueCTAClick(
            offers,
            selected,
            cost
          ).gaData;
          this.analyticsService.eventEmitter(gaData);
        })
      ),
    { dispatch: false }
  );

  ThumbnailClick$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromAnalytics.ProductDetailsThumbnailClick),
        withLatestFrom(
          this.viewOffersService.offers$,
          this.productDetailsService.selected$,
          this.completeOrderService.replacementCost$
        ),
        tap(([, offers, selected, replacementCost]) => {
          const gaData = new GAProductDetailsThumbnailClick(
            offers,
            selected,
            replacementCost
          ).gaData;
          this.analyticsService.eventEmitter(gaData);
        })
      ),
    { dispatch: false }
  );

  DeliveryUnavailableModal$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromAnalytics.DeliveryUnavailableModal),
        withLatestFrom(
          this.viewOffersService.offers$,
          this.productDetailsService.selected$,
          this.completeOrderService.replacementCost$
        ),
        tap(([, offers, selected, replacementCost]) => {
          const gaData = new GADeliveryUnavailableModal(
            offers,
            selected,
            replacementCost
          ).gaData;
          this.analyticsService.eventEmitter(gaData);
        })
      ),
    { dispatch: false }
  );

  DeliveryApiErrorModal$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromAnalytics.DeliveryApiErrorModal),
        withLatestFrom(
          this.viewOffersService.offers$,
          this.productDetailsService.selected$,
          this.completeOrderService.replacementCost$
        ),
        tap(([, offers, selected, replacementCost]) => {
          const gaData = new GADeliveryApiErrorModal(
            offers,
            selected,
            replacementCost
          ).gaData;
          this.analyticsService.eventEmitter(gaData);
        })
      ),
    { dispatch: false }
  );
}
